import axios from 'axios';

export default async function getVerificationStatus(
  accessToken,
  userId,
  locationId,
) {
  const requestOptions = {
    headers: {
      'access-token': accessToken,
    },
  };

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_GOOGLE_API_URL}/fetch/verification/status/${userId}/${locationId}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    throw err.response.data;
  }
}
